import * as React from 'react';
import { SuggestionItem, AgentType } from './types';
import { SUPPORT_SUGGESTIONS, BI_SUGGESTIONS, AGENT_CONFIG } from './constants';

interface SuggestionsPanelProps {
  selectedAgent: AgentType;
  classes: any;
  t: any;
  onSuggestionClick: (query: string) => void;
}

const SuggestionsPanel: React.FC<SuggestionsPanelProps> = ({ 
  selectedAgent, 
  classes, 
  t, 
  onSuggestionClick 
}) => {
  const suggestions = selectedAgent === AgentType.SUPPORT ? SUPPORT_SUGGESTIONS : BI_SUGGESTIONS;
  const config = AGENT_CONFIG[selectedAgent.toUpperCase() as keyof typeof AGENT_CONFIG];

  const renderSuggestionCard = (suggestion: SuggestionItem, index: number) => (
    <div
      key={index}
      className={classes.suggestionCard}
      onClick={() => onSuggestionClick(suggestion.query)}
    >
      <div className={classes.suggestionIcon}>
        {suggestion.icon}
      </div>
      <div className={classes.suggestionTitle}>
        {t(suggestion.title)}
      </div>
      <div className={classes.suggestionSubtitle}>
        {t(suggestion.subtitle)}
      </div>
    </div>
  );

  const renderWelcomeMessage = () => (
    <div className={classes.welcomeContainer}>
      <div className={classes.messageItem}>
        <div className={classes.messageAvatar}>AI</div>
        <div className={classes.messageContent}>
          <div className={classes.aiMessage}>
            {t(config.welcomeMessage)}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={classes.welcomeWrapper}>
      {renderWelcomeMessage()}
      <div className={classes.suggestions}>
        <div className={classes.suggestionsTitle}>
          {t('Suggested actions')}
        </div>
        <div className={classes.suggestionsGrid}>
          {suggestions.map(renderSuggestionCard)}
        </div>
      </div>
    </div>
  );
};

export default SuggestionsPanel; 